export default __webpack_public_path__ + "static/media/71t.ed2155b8.jpg";